package com.karawek.core.ui.haptics

import androidx.compose.runtime.Composable

enum class HapticType {
    Tap,
    Selection,
    Success,
    Warning,
    Error,
}

/**
 * Semantic haptic feedback for UI interactions.
 *
 * Safe to call on all platforms.
 */
@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
expect object CoreHaptics {
    fun perform(type: HapticType)
}
